import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useLenis } from '../../hooks/useLenis'
import { useReducedMotion } from '../../hooks/useReducedMotion'
import { ScrollTrigger } from '../../utils/gsap'

/** Enables Lenis smooth scroll on desktop when motion is allowed. */
export default function SmoothScrollProvider({ children }) {
  const reducedMotion = useReducedMotion()
  const location = useLocation()

  useLenis(!reducedMotion)

  useEffect(() => {
    const refresh = () => ScrollTrigger.refresh()
    requestAnimationFrame(refresh)
    const timeoutId = window.setTimeout(refresh, 150)
    return () => window.clearTimeout(timeoutId)
  }, [location.pathname])

  return children
}
